import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import OrderList from './OrderList';
import { updateOrderAction } from '../../../services/request';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';
import { ConfirmDialog } from '../../../components/ConfirmDialog';

export const PLOrderList = props => {
  const { loading, mutate, error } = useMutation(updateOrderAction);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [updateSingleRowData, setUpdateSingleRowData] = React.useState([]);
  const [updateStatusData, setUpdateStatusData] = React.useState({});
  const [confirmChangeState, setConfirmChangeState] = React.useState(false);

  const prepareHandleConfirmStatusData = (id, identifier) => {
    setUpdateStatusData({ id, identifier });
    setConfirmChangeState(true);
  };

  const handleAccomodationCheck = async (id, identifier) => {
    const { error: mutateError, payload } = await mutate(id, { accommodated: true });
    if (!mutateError) {
      setUpdateSingleRowData([id, 'accommodated', true]);
      setSeverity('success');
      setTitle(`Pomyślnie zakwaterowano. Zamówienie ${identifier}`);
      setMessage(payload[0]);
      setShowAlert(true);

    } else {
      setSeverity('error');
      setTitle(`Nie udało się zakwaterować. Zamówienie ${identifier}`);
      setMessage(_.isArray(payload) ? payload[0] : '');
      setShowAlert(true);
    }
  };

  const handleConfirmStatus = async () => {
    setConfirmChangeState(false);
    const { error: mutateError, payload } = await mutate(updateStatusData.id, { state: 'CON' });
    if (!mutateError) {
      setUpdateSingleRowData([updateStatusData.id, 'state', 'CON']);
      setSeverity('success');
      setTitle(`Pomyślnie zmieniono status zamówienia ${updateStatusData.identifier}`);
      setMessage(payload[0]);
      setShowAlert(true);

    } else {
      setSeverity('error');
      setTitle(`Nie udało się zmienić statusu na potwierdzony zamówienia ${updateStatusData.identifier}`);
      setMessage(_.isArray(payload) ? payload[0] : '');
      setShowAlert(true);
    }
  };

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <OrderList {...props} handleAccomodationCheck={handleAccomodationCheck} handleConfirmStatus={prepareHandleConfirmStatusData} updateSingleRowData={updateSingleRowData} />
      <ConfirmDialog
        title="Potwierdzić zamówienie?"
        open={confirmChangeState}
        setOpen={setConfirmChangeState}
        onConfirm={handleConfirmStatus}
        disabled={loading}
      >
        Czy na pewno chcesz potwierdzić to zamówienie?
      </ConfirmDialog>
    </>

  );
};
